// @Version: 1.0.0
export enum FC_TOGGLE {
   TOGGLEBUTTON = "togglebutton"
}